import { render, staticRenderFns } from "./filterPurchase.vue?vue&type=template&id=348a316c&scoped=true&"
import script from "./filterPurchase.vue?vue&type=script&lang=js&"
export * from "./filterPurchase.vue?vue&type=script&lang=js&"
import style0 from "./filterPurchase.vue?vue&type=style&index=0&id=348a316c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a316c",
  null
  
)

export default component.exports